export const CREATE = "CREATE"
export const UPDATE = "UPDATE"
export const DELETE = "DELETE"
export const FETCH_ALL = "FETCH_ALL"
export const LIKE = "LIKE"
export const AUTH = "AUTH"
export const LOGOUT = "LOGOUT"
export const FETCH_BY_SEARCH = "FETCH_BY_SEARCH"
export const FETCH_POST = "FETCH_POST"
export const START_LOADING = "START_LOADING"
export const END_LOADING = "END_LOADING"
export const COMMENT = "COMMENT"
export const DELETEACCOUNT = "DELETEACCOUNT"
export const FETCH_STATS = "FETCHSTATS"
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST"
export const CHANGE_PASSWORD_REQUEST_FAILURE = "CHANGE_PASSWORD_REQUEST_FAILURE"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE"
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST"
export const FORGOT_PASSWORD_REQUEST_FAILURE = "FORGOT_PASSWORD_REQUEST_FAILURE"
export const EMAIL_VERIFICATION_REQUEST = "EMAIL_VERIFICATION_REQUEST"
export const EMAIL_VERIFICATION_REQUEST_FAILURE = "EMAIL_VERIFICATION_REQUEST_FAILURE"
export const EMAIL_VERIFICATION_SUCCESS = "EMAIL_VERIFICATION_SUCCESS"
export const EMAIL_VERIFICATION_FAILURE = "EMAIL_VERIFICATION_FAILURE"